import React from "react";

const UseFormContent = ({ content, type, field, register, watch, error }) => {
  return <div>{content}</div>;
};

export default UseFormContent;
